import { SET_SDE_ANALYSIS_REPORT, SET_HDE_ANALYSIS_REPORT } from "./mutations";
import { store } from "../../index";
import SDEAnalysis from "../../../models/qualityOfEarnings/SDEAnalysis";
import HDEAnalysis from "../../../models/qualityOfEarnings/HDEAnalysis";
import { fetchCompanyMonthlyProfitAndLoss } from "../financials/actions";

export const generateSDEAnalysis =
  (options = { clearCache: false }) =>
  async (dispatch) => {
    const { companyId, dataSettings } = store.getState().appState;

    await dispatch(
      fetchCompanyMonthlyProfitAndLoss(
        { companyId },
        {
          periodsToCompare: dataSettings.yearsToFetch,
        }
      )
    );

    const { currentCompanyMonthlyProfitAndLoss } = store.getState().financials;
    const { currentCompanySDEAnalysis } = store.getState().qualityOfEarnings;
    const { taxes } = store.getState();

    //get taxes
    const socialSecurityTax = taxes.socialSecurity / 100;
    const medicareTax = taxes.medicare / 100;

    //get variables of currentCompanyMonthlyProfitAndLoss. They are always date descendant
    const salesRevenue = currentCompanyMonthlyProfitAndLoss.yearlyTotalSales.reverse();
    const yearsFormatted = currentCompanyMonthlyProfitAndLoss.yearsFormatted.reverse();
    const EBITDA = currentCompanyMonthlyProfitAndLoss.yearlyEBITDAAsDefined.reverse();

    let _SDEAnalysis;

    if (options.clearCache || !currentCompanySDEAnalysis) {
      _SDEAnalysis = new SDEAnalysis({
        yearsFormatted,
        autoAssumptions: {
          salesRevenue,
          EBITDA
        },
        socialSecurityTax,
        medicareTax
      });
    } else {
      _SDEAnalysis = new SDEAnalysis({
        ...currentCompanySDEAnalysis,
        yearsFormatted,
        autoAssumptions: {
          salesRevenue,
          EBITDA
        },
        socialSecurityTax,
        medicareTax
      });
    }

    dispatch({
      type: SET_SDE_ANALYSIS_REPORT,
      payload: _SDEAnalysis,
    });
  };

export const updateSDEAnalysis =
  (label, value, id, type, key) => (dispatch) => {
    const { currentCompanyMonthlyProfitAndLoss } = store.getState().financials;
    const { currentCompanySDEAnalysis } = store.getState().qualityOfEarnings;

    if(label === "MANUAL") {
      //part for independence and manual Sales / EBITDA update
      if(type === "independence") currentCompanySDEAnalysis.independence = value;
      else currentCompanySDEAnalysis[type][id].value = Number(value.replace(/,/g, ""));
    }
    else {
      //part for matrix update
      const variableName = "matrix" + label + "Adj"; //we have several variables like this in store
      const yearsFormatted =
        currentCompanyMonthlyProfitAndLoss.yearsFormatted.reverse();
      const matrix = currentCompanySDEAnalysis[variableName]; //matrixManagementAdj, matrixDiligenceAdj ..
      const len = matrix.length; //length of matrix array

      //Modify changed value itself in store
      if (type === "note") currentCompanySDEAnalysis["note" + label] = value;
      else if (type === "series") {
        //series is array that has several DateAndValue objects.
        matrix[id].series.filter((obj) => obj.date === key)[0].value = Number(
          value.replace(/,/g, "")
        ); //input is string that includes comma
      } else {
        matrix[id][type] = value;
      }

      if (matrix[len - 1].name !== "") {
        //add a new item(object) to matrix when the name of last item exists
        matrix[len] = {
          id: len,
          name: "",
          series: yearsFormatted.map((year) => ({ date: year, value: "" })),
          comment: "",
        };
      } else {
        //delete the last item(object) of matrix when the name of 2nd last item is null
        if (len > 1 && matrix[len - 2].name === ""){
          matrix.pop();      //decrease the number of items
          matrix[len - 2].series.map((obj) => obj.value = "");     //clear the new last item
        }
      }
    }

    dispatch({
      type: SET_SDE_ANALYSIS_REPORT,
      payload: new SDEAnalysis({
        ...currentCompanySDEAnalysis,
      }),
    });
  };

export const generateHDEAnalysis =
  (options = { clearCache: false }) =>
  async (dispatch) => {
    const { companyId, dataSettings } = store.getState().appState;

    await dispatch(
      fetchCompanyMonthlyProfitAndLoss(
        { companyId },
        {
          periodsToCompare: dataSettings.yearsToFetch,
        }
      )
    );

    const { currentCompanyMonthlyProfitAndLoss } = store.getState().financials;
    const { currentCompanyHDEAnalysis } = store.getState().qualityOfEarnings;
    const { taxes } = store.getState();

    //get variables of currentCompanyMonthlyProfitAndLoss. They are always date descendant
    const salesRevenue = currentCompanyMonthlyProfitAndLoss.yearlyTotalSales.reverse();
    const yearsFormatted = currentCompanyMonthlyProfitAndLoss.yearsFormatted.reverse();
    const EBITDA = currentCompanyMonthlyProfitAndLoss.yearlyEBITDAAsDefined.reverse();

    //get taxes
    const socialSecurityTax = taxes.socialSecurity / 100;
    const medicareTax = taxes.medicare / 100;

    let _HDEAnalysis;

    if (options.clearCache || !currentCompanyHDEAnalysis) {
      _HDEAnalysis = new HDEAnalysis({
        yearsFormatted,
        autoAssumptions: {
          salesRevenue,
          EBITDA
        },
        socialSecurityTax,
        medicareTax,
      });
    } else {
      _HDEAnalysis = new HDEAnalysis({
        ...currentCompanyHDEAnalysis,
        yearsFormatted,
        autoAssumptions: {
          salesRevenue,
          EBITDA
        },
        socialSecurityTax,
        medicareTax,
      });
    }

    dispatch({
      type: SET_HDE_ANALYSIS_REPORT,
      payload: _HDEAnalysis,
    });
  };

export const updateHDEAnalysis =
  (label, value, id, type, key) => (dispatch) => {
    const { currentCompanyMonthlyProfitAndLoss } = store.getState().financials;
    const { currentCompanyHDEAnalysis } = store.getState().qualityOfEarnings;

    if(label === "MANUAL") {
      //part for independence and manual Sales / EBITDA update
      if(type === "independence") currentCompanyHDEAnalysis.independence = value;
      else currentCompanyHDEAnalysis[type][id].value = Number(value.replace(/,/g, ""));
    }
    else {
      //part for matrix update
      const yearsFormatted =
        currentCompanyMonthlyProfitAndLoss.yearsFormatted.reverse();
      const matrix = currentCompanyHDEAnalysis["matrix" + label];
      const len = matrix.matrix.length; //length of matrix array

      //Modify changed value itself in store
      if (type === "note") matrix.note = value;
      else if (type === "series") {
        //series is array that has several DateAndValue objects.
        matrix.matrix[id].series.filter((obj) => obj.date === key)[0].value = Number(
          value.replace(/,/g, "")
        ); //input is string that includes comma
      }
      else {
        matrix.matrix[id][type] = value;
      }

      if (matrix.matrix[len - 1].name !== "") {
        //add a new item(object) to matrix when the name of last item exists
        matrix.matrix[len] = {
          id: len,
          name: "",
          series: yearsFormatted.map((year) => ({ date: year, value: "" })),
          comment: "",
        };
      } else {
        //delete the last item(object) of matrix when the name of 2nd last item is null
        if (len > 1 && matrix.matrix[len - 2].name === ""){
          matrix.matrix.pop();      //decrease the number of items
          matrix.matrix[len - 2].series.map((obj) => obj.value = "");     //clear the new last item
        }
      }
    }

    dispatch({
      type: SET_HDE_ANALYSIS_REPORT,
      payload: new HDEAnalysis({
        ...currentCompanyHDEAnalysis,
      }),
    });
  };

export const updatePercentageStatus =
  (value) => (dispatch) => {
    const { currentCompanyHDEAnalysis } = store.getState().qualityOfEarnings;
    currentCompanyHDEAnalysis.percentage = value;

    dispatch({
      type: SET_HDE_ANALYSIS_REPORT,
      payload: new HDEAnalysis({
        ...currentCompanyHDEAnalysis,
      }),
    });
  };